export default "__VITE_ASSET__c3d5e6ca__"